import { AppFormItem, AppFormItemProps, AppRadioButton, AppRadioGroup } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { settingsTexts } from 'consts/text';

type MealPaymentTypePickerElementProps = AppFormItemProps & {
    disabled?: boolean;
};

const items: { label: string; value: string }[] = [
    {
        label: settingsTexts.settlements.meals.formLabels.ownKitchen,
        value: 'OWN_KITCHEN',
    },
    {
        label: settingsTexts.settlements.meals.formLabels.catering,
        value: 'CATERING',
    },
];

export const MealProviderTypePickerElement = ({
    disabled,
    ...props
}: MealPaymentTypePickerElementProps) => {
    const radioElements = items.map(({ value, label }) => (
        <AppRadioButton key={value} value={value}>
            {label}
        </AppRadioButton>
    ));

    return (
        <AppFormItem
            label={settingsTexts.settlements.meals.formLabels.mealProvider}
            name={formFields.mealProviderType}
            disabled={disabled}
            {...props}
        >
            <AppRadioGroup disabled={disabled}>{radioElements}</AppRadioGroup>
        </AppFormItem>
    );
};
